/**
 * Hand a file the API returned to the browser to save.
 *
 * The SDK resolves a binary response as a `Blob`; an object URL on a
 * throwaway link is the one way to name the saved file.
 */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.click()
  URL.revokeObjectURL(url)
}

/** The same, under the name the Costs, Fees and AI Listing pages use. */
export const downloadBlob = saveBlob

/** The file name a response's Content-Disposition header names, or a fallback. */
export function attachmentName(response: Response | undefined, fallback: string): string {
  const header = response?.headers.get('content-disposition') ?? ''
  return /filename="([^"]+)"/.exec(header)?.[1] ?? fallback
}
